import React, { useState } from 'react';
import '../../../components/table/table.css';
import { FaExclamationTriangle, FaMinusCircle, FaPlusCircle } from 'react-icons/fa';
import toTitleCase from '../../../lib/titleCase/TitleCase';
import StatusBadge from './StatusBadge';
import { useNavigate } from 'react-router-dom';



const CorrectionRequests = ({last_ten_correction}) => {
    const [showTable, setShowTable] = useState(true);
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/Hrcorrection');
    };

      
    return (
        <div className="leave-wrapper">
            <div className="leave-header">
                <div className="leave-title">
                    <FaExclamationTriangle className="leave-icon" />
                    <span>Last 10 Correction Requests</span>
                </div>
                <div className="leave-actions">
                    <button className="view-all-btn" onClick={handleClick}>
                        View All
                    </button>
                    <button className="icon-toggle-btn" onClick={() => setShowTable(!showTable)}>
                        {showTable ? <FaMinusCircle /> : <FaPlusCircle />}
                    </button>
                </div>
            </div>

            {showTable && (
                <div className="table-container" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <table className="leave-table">
                        <thead>
                            <tr>

                                <th className="py-0 px-1">Employee</th>
                                <th className="py-0 px-1">Type</th>
                                <th className="py-0 px-1">Date</th>
                                <th className="py-0 px-1">Details</th>
                                <th className="py-0 px-1 sticky-col-right">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {last_ten_correction?.map(request => (
                                <tr key={request.id} style={{whiteSpace:"nowrap"}}>

                                    <td className="py-0 px-1 text-nowrap">{toTitleCase(request.name)}</td>
                                    <td className="py-0 px-1">{toTitleCase(request.correction_request_type)}</td>
                                    <td className="py-0 px-1 text-nowrap">{request.date}</td>
                                    <td className="py-0 px-1 text-nowrap">
                                        {toTitleCase(request.description.replace(/<[^>]*>/g, ""))}
                                    </td>
                                    <td className='sticky-col-left'>
                                        <StatusBadge status={toTitleCase(request.approval_status)} />
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div style={{ flex: '0 0 10px' }}></div>
                </div>
            )}
        </div>
    );
};

export default CorrectionRequests;

